module.exports = __webpack_public_path__ + "img/Publish-en.7c0de83.png";